import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button } from '@habitech/call-to-action';
import Loading from 'src/components/common/Loading/Loading';
import { WrapperButton } from '../styles';
import { useAppDispatch } from 'src/hooks/redux';
import { setUserEmail } from 'src/redux/broker_configuration/slice';

export const typeForm = {
    create: 'Crear',
    edit: 'Editar',
};

type PropsForm = {
    type?: 'users' | 'propierties';
    handleSearch?: Function;
    loadingList?: boolean;
    resetValues?: Function;
};

const initialValues = {
    from_xml: '0',
    list: '',
};

const Form = ({ type, loadingList, handleSearch }: PropsForm) => {
    const dispatch = useAppDispatch();
    const validationSchema = yup.object({
        list: yup.string().required('Ingresa un correo válido.'),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: (values: any) => {
            handleSearch(values);
            dispatch(setUserEmail(values.list))
        },
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <TextField
                    dataId="list"
                    name="list"
                    label={'Email'}
                    originType="pcom"
                    placeHolder="Ingresa un email"
                    innerLabel
                    value={formik.values.list}
                    onChange={(_, _vale, e) => formik.handleChange(e)}
                    error={Boolean(formik.errors.list)}
                    errorMessage={JSON.stringify(formik.errors.list)}
                    maxLength={3000}
                />
                <WrapperButton>
                    {!loadingList ? (
                        <>
                            <Button dataId="button-search" originType="pcom" size="large" type="submit">
                                Buscar
                            </Button>
                        </>
                    ) : (
                        <Loading className="loader-button" />
                    )}
                </WrapperButton>
            </form>
        </>
    );
};

export default Form;
